export const DISABLE_LINK = {
  PRODUCTS: '/produkty',
  REALIZATIONS: '/realizacje',
  HOME_STORIES: '/home-stories',
};
